module.exports = __webpack_public_path__ + "teqbahn-assets/media/3.f4ea03bf.png";